export const habaCart = {
  habaVoucher: {
    title: 'Do you have a promotional code?',
    coupon: 'promotional code',
    apply: 'Apply',
    placeholder: 'Promo code',
    error: 'Please enter a code',
    applyVoucherSuccess: '{{voucherCode}} has been applied.',
    removeVoucherSuccess: '{{voucherCode}} has been removed.',
    availableCoupons: 'Available coupons',
    availableCouponsLabel: 'You can add these coupons to this order.',
    vouchersApplied: 'Applied coupons:',
    promotionInfo: {
      headline: 'All information and conditions',
      labelPromo: 'Promotion code',
      labelCampaign: 'Campaign',
    },
  },
  habaMiniCart: {
    cart: 'Cart',
    emptyCart: 'Your cart is empty.',
    viewCart: 'View cart',
    title: 'Your cart',
    checkout: 'Proceed to checkout',
    offer: {
      question: 'Do you need a quote?',
      description: 'In the cart you can request a cost estimate for funding applications.',
    },
  },
  habaPopupCart: {
    headline: 'Item added to shopping cart',
    btn: {
      continue: 'Continue shopping',
      toCart: 'To the shopping cart',
    },
    recommendationsTitle: 'Products that might also interest you',
  },
  habaCart: {
    emptyCartDescription: 'Your cart is empty.',
    myCart: 'My cart',
    toHome: 'Back to the homepage',
    offer: {
      headline: 'Request a non-binding preliminary offer',
      info: 'For a request for a quote, we will send you your current shopping cart. Please place all items (in the appropriate configuration and with the respective quantities) in your shopping cart. Then click on "Request an offer" and your request will be sent to our employees. We will then <a href="{{contactUrl}}" target="_blank">contact</a> you as soon as possible.',
      button: 'Request now without obligation',
      label: 'Information',
      body: {
        info: 'For a quote request, the products in your shopping cart are transmitted:',
        login: 'Log in to your customer account',
        line1: 'Make your request with just one click on "Request without obligation now".',
        line2: 'Our staff will contact you as soon as possible.',
        success: 'Your request was successfully submitted',
        line3: '( i ) Items with promotional prices cannot be considered individually – their regular price will be used as the basis.',
        line4: 'Of course, we will provide you with an individual quote for your entire shopping cart.'
      },
      inputPlaceholder:
        'You can enter important information about your preliminary offer in the comment field.',
      successMessage: 'Your request has been successfully submitted',
      errorMessage: 'Your request could not be sent.',
      billingAddressHeadline: 'Add billing address',
      billingAddressInformation:
        'In order to be able to send you a non-binding preliminary offer, we need a billing address.',
    },
    ociPunchoutError: 'Unable to create the punchout order',
    ociPunchoutMinCartError: 'The minimum order value of {{value}} has not yet been reached.',
  },
  habaCartDetails: {
    title: 'Cart summary',
    info: 'You can enter your promotional code in the last order step ',
    productsValue: 'Products Value',
    shippingValue: 'Shipping Value',
    freightValue: 'Freight costs',
    totalValue: 'Total',
    proceedToCheckout: 'Proceed to Checkout',
    vat: 'included VAT',
    payment: 'How you can pay',
    punchout: 'Transfer order',
    punchoutSuccess: 'The shopping cart has been transferred to your procurement system',
    punchoutError: 'The shopping cart could not be transferred to your procurement system',
    // new
    details: {
      initialPrice: 'Ursprünglicher Warenwert',
      reductions: 'Ihre Ersparnisse',
      currentPrice: 'Current Price',
      currentPriceDetails: '(alle Aktionen angewendet)',
      returnVoucher: 'Gutscheineinlösung',
      totalNet: 'Gesamt Netto',
      includingTva: 'gesetzliche MwSt.',
      deliveryCost: 'Versandkosten Brutto',
      deliveryCostsBrut: 'Frachtkosten Brutto',
      deliveryCostNet: 'Shipping costs net',
      freightCostNet: 'Net freight costs',
      totalBrut: 'Total value',
      helperTitle: 'Vorteilscode und Gutscheine können im letzten Schritt eingelöst werden.',
      energySurcharge: 'Energy surcharge',
      energySurchargeInfo: 'Due to rising energy and logistics costs, we are temporarily charging an additional fee.'
    },
  },
  directOrderForm: {
    articleNumber: 'Article number',
    quantity: 'Quantity',
    price: 'Price',
    searchArticle: 'Search article',
    addMoreItems: 'Add more items',
    addItemsToCart: 'Add items to cart',
    viewAll: 'View all',
    articlesFoundFor: '{{ number }} Articles found for “{{ query }}”',
    articleCode: 'Article number: {{ code }}',
    choose: 'Choose',
    loadMore: 'Load more',
    messageAddedToCart: 'Your items have been added to the shopping cart',
    noResults: 'There is no matching article for this article number',
    unavailableProducts: 'Unavailable products',
    unavailableProductsDescription:
      'At least one of your added products is no longer available.\nTo add the list to your shopping cart, you must remove the products that are no longer available.',
    removeProducts: 'Remove product',
    reducedQuantityMessage:
      'The added quantity for at least one of the added products is no longer available.',
  },
};
